<template>
      <v-layout row wrap justify-center align-center>
          <v-flex xs12>
              <v-card>
                  <v-card-title>
                    <v-layout row wrap align-end>
                    <v-flex>
                      <h1> Busca de Projetos </h1>
                      <v-spacer></v-spacer>
                    </v-flex>
                    <v-flex>
                       <v-text-field
                        append-icon="search"
                        label="Pesquise os resultados"
                        single-line
                        hide-details
                        v-model="search"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    </v-flex>
                    </v-layout>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap align-end>
                    <v-flex xs6>
                      <v-autocomplete
                      style="width: 95%"
                      label="Filtrar por Turma"
                      :items="turmas"
                      item-text="name"
                      item-value="id"
                      v-model="selectTurma"
                      max-height="400"
                      hint="Escolha a turma"
                      persistent-hint
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs6>
                      <v-autocomplete
                      label="Filtrar por Integrantes"
                      :disabled="intBusca"
                      :items="alunos"
                      item-text="username"
                      item-value="id"
                      v-model="integrantes"
                      max-height="400"
                      hint="Escolha o aluno"
                      persistent-hint
                      ></v-autocomplete>
                    </v-flex>
                    </v-layout>
                    <v-spacer></v-spacer>
                      
                    <v-layout justify-end >
                      <v-checkbox
                        v-model="exibir"
                        label="Exibir apenas meus projetos"
                      ></v-checkbox>
                      <v-btn
                        color="primary"
                        @click="limpar"
                      >Limpar
                      </v-btn>
                    </v-layout>
                                  
                      <v-container>
                      <v-layout row>
                          <v-flex xs-8>
                        <v-data-table
                        :headers="headers"
                        :items="rows"
                        :search="search"
                        :loading="animation"
                        >
                        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                        <template slot="items" slot-scope="props">
                            <td @click="gotoProject(props.item)">
                                <v-avatar :tile="true"
                                size="60">
                                <img class= "img-thumbnail img-search" :id="'logo' + props.item.id" :src="props.item.image" 
                                  @error="imageError(props.item)" />
                                </v-avatar>
                                </td>
                            <td @click="gotoProject(props.item)">{{ props.item.name }}</td>
                            <td @click="gotoProject(props.item)">{{ props.item.turma }}</td>
                            <td @click="gotoProject(props.item)">{{ props.item.autores }}</td>
                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                            Sua busca por "{{ search }}" não encontrou resultados.
                        </v-alert>
                        <template v-if="mensagem" slot="no-data">
                            Ops... Nenhum dado no momento
                        </template>
                        <template v-if="!mensagem" slot="no-data">
                            Carregando os dados
                        </template>
                        </v-data-table>
                          </v-flex>
                      </v-layout>
                      </v-container>
                  </v-card-text>
              </v-card>
          </v-flex>
      </v-layout>
</template>

<script>
import api from '@/api'

export default {
  data () {
    return {
      search: '',
      animation: true,
      autores: [],
      turmas: {},
      alunos: {},
      papel: '',
      teste: null,
      medium: null,
      intBusca: true,
      mensagem: false,
      selectTurma: '',
      exibir: true,
      integrantes: '',
      headers: [
        { text: 'Imagem', sortable: false, value: 'image' },
        { text: 'Nome', value: 'name' },
        { text: 'Turma', value: 'turma' },
        { text: 'Integrantes', value: 'autores' }
      ],
      rows: []
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    gotoProject (row) {
      this.$router.push(
        {name: 'projeto-detail',
          params: {'id': row.id}
        })
    },
    permissao () {
      if (this.$store.state.selectedRole.name !== 'Aluno') {
        this.intBusca = false
      } else {
        if (!this.exibir) {
          this.intBusca = false
        } else {
          this.intBusca = true
        }
      }
    },
    limpar () {
      this.selectTurma = ''
      this.integrantes = ''
      this.getProject()
    },
    getAutores (dados, index) {
      dados = dados.map((valor, index) => {
        valor = valor.integrantes.map((aluno, index) => {
          return aluno.username
        })
        return valor
      })
      for (let index = 0; index < dados.length; index++) {
        dados[index] = dados[index].toString()
      }
      // console.log('aqui', dados)
      return dados
    },
    isMediador (username) {
      return this.$store.state.user.username === username
    },
    filtroGeral () {
      var pesquisa
      if (!this.exibir) {
        if (this.selectTurma !== '') {
          pesquisa = 'projetos/?turma=' + this.selectTurma
        }
        if (this.integrantes !== '') {
          pesquisa = 'projetos/?integrantes=' + this.integrantes
        }
        if (this.selectTurma !== '' && this.integrantes !== '') {
          pesquisa = 'projetos/?integrantes=' + this.integrantes + '&turma=' + this.selectTurma
        }
      } else {
        if (this.$store.state.selectedRole.name === 'Mediador') {
          if (this.selectTurma !== '') {
            pesquisa = 'projetos/?turma=' + this.selectTurma + '&moderador=' + this.$store.state.user.id
          }
          if (this.integrantes !== '') {
            pesquisa = 'projetos/?integrantes=' + this.integrantes + '&moderador=' + this.$store.state.user.id
          }
          if (this.selectTurma !== '' && this.integrantes !== '') {
            pesquisa = 'projetos/?integrantes=' + this.integrantes + '&turma=' + this.selectTurma + '&moderador=' + this.$store.state.user.id
          }
        }
        if (this.$store.state.selectedRole.name === 'Aluno') {
          if (this.selectTurma !== '') {
            pesquisa = 'projetos/?turma=' + this.selectTurma + '&integrantes=' + this.$store.state.user.id
          }
        }
        if (this.$store.state.selectedRole.name !== 'Aluno' && this.$store.state.selectedRole.name !== 'Mediador') {
          if (this.selectTurma !== '') {
            pesquisa = 'projetos/?turma=' + this.selectTurma
          }
          if (this.integrantes !== '') {
            pesquisa = 'projetos/?integrantes=' + this.integrantes
          }
          if (this.selectTurma !== '' && this.integrantes !== '') {
            pesquisa = 'projetos/?integrantes=' + this.integrantes + '&turma=' + this.selectTurma
          }
        }
      }
      api.request('GET', pesquisa).then(response => {
        var dados = this.getAutores(response.data)
        var arr = response.data.map(function (data, index) {
          return {
            image: data.image_small,
            imagem: data.image,
            id: data.id,
            name: data.name,
            url: data.url,
            turma: data.turma_name,
            autores: dados[index]
          }
        })
        this.rows = arr
        // console.log(arr)
        this.animation = false
      })
    },
    getProject () {
      var pesquisa = 'projetos/'
      if (this.$store.state.selectedRole.name === 'Mediador') {
        pesquisa = 'projetos/?moderador=' + this.$store.state.user.id
      }
      if (this.$store.state.selectedRole.name === 'Aluno') {
        pesquisa = 'projetos/?integrantes=' + this.$store.state.user.id
      }
      if (!this.exibir) {
        pesquisa = 'projetos/'
      }
      api.request('GET', pesquisa).then(response => {
        var dados = this.getAutores(response.data)
        var arr = response.data.map(function (data, index) {
          return {
            image: data.image_small,
            imagem: data.image,
            id: data.id,
            name: data.name,
            url: data.url,
            turma: data.turma_name,
            autores: dados[index]
          }
        })
        this.rows = arr
      // console.log(arr)
        this.animation = false
        this.mensagem = true
      })
    },
    imageError (prop) {
      this.onerror = null
      var x = document.getElementById('logo' + prop.id)
      x.src = prop.imagem
    }
  },
  mounted () {
    this.getProject()
    this.permissao()
    api.request('GET', 'turmas/').then(response => {
      this.turmas = response.data
    })
    api.request('GET', 'users/').then(response => {
      this.alunos = response.data
    })
    this.$watch('integrantes', function () {
      this.filtroGeral()
    })
    this.$watch('selectTurma', function () {
      this.filtroGeral()
    })
    this.$watch('exibir', function () {
      this.getProject()
      this.permissao()
      this.selectTurma = ''
      this.integrantes = ''
    })
  }
}
</script>

<style lang="scss" scoped>

td:hover{
  cursor: pointer; 
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/Projetos/Search.vue